import Button from '../../../../shared/Buttons/Button'
import { ITextOption } from '../../sandbox.types'
import { ReactComponent as RemoveIcon } from '../../../../asserts/icons/xmark.svg'
import { memo, useState } from 'react'
import css from './textOption.module.css'
import EditTextOptionModal from './EditTextOptionModal'

interface IProps {
  index: number
  option: ITextOption
  onDelete: (index: number) => void
  onChange: (index: number, changed: ITextOption) => void
}

const TextOption = (props: IProps) => {
  const [modalOpen, setModalOpen] = useState(false)

  return (
    <div className={css.wrapper} data-right-answer={props.option.rightAnswer}>
      {modalOpen && (
        <EditTextOptionModal
          onClose={() => setModalOpen(false)}
          option={props.option}
          onChange={(o) => {
            props.onChange(props.index, o)
            setModalOpen(false)
          }}
        />
      )}
      <RemoveIcon onClick={() => props.onDelete(props.index)} className={css.cancel} />
      <Button onClick={() => setModalOpen(true)}>{props.option.text}</Button>
    </div>
  )
}

export default memo(TextOption)
